var map = {
	"./logo-folddisco_2x.png": 81217,
	"./logo-foldmason_2x.png": 57305,
	"./logo-foldseek_2x.png": 91673,
	"./logo-mmseqs_2x.png": 12564,
	"./logo-riboseek_2x.png": 59104
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 80469;